import Vue from 'vue'
import CA, { computed } from '@vue/composition-api'
import { sortBy } from 'lodash'
Vue.use(CA)

import { reactive } from '@vue/composition-api'
import { routeCurrent } from '@iez/core/router'
import { state as stateBlockingMenu } from '../blocking-menu/'
import user from '@iez/lib/user/'

export const state = reactive({
  _bottomNavigations: [],
  bottomNavigations: computed({
    get: () => state._bottomNavigations,
    set: value => {
      state._bottomNavigations = value
    }
  }),

  isActive: computed(() =>
    (user.hasToBeReady ? user.isReady : true) &&
    !stateBlockingMenu.model &&
    !!state.bottomNavigations.find(({ route: { path }, isHiddenOnActive }) => path === routeCurrent.path && !isHiddenOnActive)
  )
})

export default () => {
  const methods = {
    add: params => {
      const { route, name, icon, position, isHiddenOnActive, size, getIsDisabled } = params
      if (state.bottomNavigations.find((instance => instance.route.path === route.path))) {
        return
      }

      state.bottomNavigations = sortBy([
        ...state.bottomNavigations,
        { name, route, icon, position, isHiddenOnActive, size, getIsDisabled }
      ], 'position')
    }
  }

  return {
    state,
    ...methods
  }
}
